import { Injectable } from '@angular/core';
import { I18nService } from 'src/app/service/i18n.service';
@Injectable({
  providedIn: 'root'
})
export class FbPaidPixelService {

  private loadOk: boolean = false;
  currentLang: string;
  trackCustom: string = '';

  constructor(private i18nService: I18nService) {
    this.currentLang = sessionStorage.getItem("lang_pref")
  }

  load(instance: String) {

    // if (!this.loadOk) {

    if (instance == "start") {
      this.trackCustom = 'CIBC_Mortgage_Pre-Qual_Tool_Application_EN'
      if (this.currentLang == "fr") {
        this.trackCustom = 'CIBC_Mortgage_Pre-Qual_Tool_Application_FR'
      }
    } else if (instance == "end") {
      this.trackCustom = 'CIBC_Mortgage_Pre-Qual_Tool_Confirmation_EN'
      if (this.currentLang == "fr") {
        this.trackCustom = 'CIBC_Mortgage_Pre-Qual_Tool_Confirmation_FR'
      }
    }

    (function (f: any, b, e, v, n, t, s) { // Getting 'non-arrow functions are forbidden' warning
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }; if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; t.type = "text/plain"; t.className = "optanon-category-C0004"; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq.disablePushState = true; //not recommended, but can be done
    (window as any).fbq('init', '1478310479108228');
    (window as any).fbq('addPixelId', 'abc');
    (window as any).fbq('init', '284592808392980');
    (window as any).fbq('trackCustom', this.trackCustom);
    this.loadOk = true;

    let content = '<noscript id=\"fb_noscript\"><img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=1478310479108228&ev="+this.trackCustom+"&noscript=1\"/><img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=284592808392980&ev="+this.trackCustom+"&noscript=1\"/></noscript>';
    $("head").append(content);
  }
}


